var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
// 代理人信息组件
var AgentInfo = function () { return (_jsxs("div", { className: "flex items-center mb-4", children: [_jsx("div", { className: "bg-gray-700 w-8 h-8 rounded-full flex items-center justify-center mr-3", children: _jsx("span", { className: "text-white font-bold", children: "M" }) }), _jsx("div", { className: "text-gray-300 font-medium", children: "Mastra Agent" })] })); };
// 欢迎消息组件
var WelcomeMessage = function () { return (_jsxs("div", { className: "chat-bubble mb-6", children: [_jsx("p", { className: "mb-3", children: "\u611F\u8C22\u60A8\u7684\u63D0\u95EE\uFF01\u4F5C\u4E3A\u4EE3\u7801\u5BA1\u67E5\u52A9\u624B\uFF0C\u6211\u9700\u8981\u770B\u5230\u5177\u4F53\u7684\u4EE3\u7801\u624D\u80FD\u63D0\u4F9B\u6709\u4EF7\u503C\u7684\u53CD\u9988\u3002\u60A8\u80FD\u5426\u63D0\u4F9B\u4EE5\u4E0B\u4FE1\u606F\uFF1A" }), _jsx("p", { className: "text-gray-400 mb-2", children: "[\u8BF7\u6C42\u4FE1\u606F]" }), _jsxs("ol", { className: "chat-list mb-4", children: [_jsx("li", { className: "chat-list-item", children: "\u60A8\u5E0C\u671B\u5BA1\u67E5\u7684\u4EE3\u7801\u7247\u6BB5\uFF08\u53EF\u4EE5\u662F\u51FD\u6570\u3001\u7C7B\u6216\u6A21\u5757\uFF09" }), _jsx("li", { className: "chat-list-item", children: "\u4EE3\u7801\u4F7F\u7528\u7684\u7F16\u7A0B\u8BED\u8A00" }), _jsx("li", { className: "chat-list-item", children: "\u4EE3\u7801\u7684\u9884\u671F\u529F\u80FD\u6216\u4E1A\u52A1\u903B\u8F91" }), _jsx("li", { className: "chat-list-item", children: "\u4EFB\u4F55\u7279\u5B9A\u7684\u5173\u6CE8\u70B9\uFF08\u5982\u6027\u80FD\u3001\u5B89\u5168\u6027\u7B49\uFF09" })] }), _jsx("p", { className: "mb-3", children: "\u4F8B\u5982\uFF0C\u60A8\u53EF\u4EE5\u8FD9\u6837\u63D0\u4F9B\uFF1A" }), _jsx("div", { className: "code-block", children: _jsx("code", { children: "# Python\u793A\u4F8B - \u7528\u6237\u8BA4\u8BC1\u6A21\u5757\ndef authenticate_user(username, password):\n    user = db.query(User).filter_by(username=username).first()\n    if user and check_password(password, user.password_hash):\n        return user\n    return None" }) }), _jsx("p", { className: "mb-2", children: "\u8FD9\u6837\u6211\u5C31\u80FD\u4E3A\u60A8\u63D0\u4F9B\uFF1A" }), _jsxs("ol", { className: "chat-list", children: [_jsx("li", { className: "chat-list-item", children: "\u5177\u4F53\u7684\u4EE3\u7801\u8D28\u91CF\u8BC4\u4F30" }), _jsx("li", { className: "chat-list-item", children: "\u9488\u5BF9\u8BE5\u8BED\u8A00\u7684\u6700\u4F73\u5B9E\u8DF5\u5EFA\u8BAE" }), _jsx("li", { className: "chat-list-item", children: "\u76F8\u5173\u7684\u5B89\u5168\u6027\u548C\u6027\u80FD\u5206\u6790" })] }), _jsx("p", { className: "mt-3", children: "\u671F\u5F85\u770B\u5230\u60A8\u7684\u4EE3\u7801\uFF01" })] })); };
// 主组件
var CodeReviewUI = function () {
    var _a = useState(''), code = _a[0], setCode = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), result = _c[0], setResult = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    var _e = useState(null), debugInfo = _e[0], setDebugInfo = _e[1];
    // API端点
    // const API_ENDPOINT = 'https://agent.wskstar.xyz/api/agents/codeReviewAgent/stream';
    var API_ENDPOINT = 'https://code-review-agent-production.zhanglong116033.workers.dev/';
    // 处理JSON流响应
    var parseStreamResponse = function (text) {
        try {
            // 检查是否是非流式响应的普通文本
            try {
                // 尝试解析为JSON
                var jsonObj = JSON.parse(text);
                // 如果是简单的JSON对象，尝试从中提取文本
                if (jsonObj.content)
                    return jsonObj.content;
                if (jsonObj.message)
                    return jsonObj.message;
                if (jsonObj.text)
                    return jsonObj.text;
                if (jsonObj.choices && jsonObj.choices[0]) {
                    var choice = jsonObj.choices[0];
                    if (choice.message && choice.message.content) {
                        return choice.message.content;
                    }
                    if (choice.text)
                        return choice.text;
                }
            }
            catch (e) {
                // 不是JSON，继续处理
            }
            // 检查是否是纯文本（没有data:前缀）
            if (!text.includes('data:')) {
                return text;
            }
            // 分割流数据成多行
            var lines = text.split('\n').filter(function (line) { return line.trim() !== ''; });
            // 提取每行中的内容部分
            var fullContent = '';
            for (var _i = 0, lines_1 = lines; _i < lines_1.length; _i++) {
                var line = lines_1[_i];
                // 如果行以data:开头
                if (line.startsWith('data:')) {
                    try {
                        // 提取data:后面的部分
                        var dataStr = line.substring(5).trim();
                        // 跳过[DONE]消息
                        if (dataStr === '[DONE]')
                            continue;
                        try {
                            // 尝试解析为JSON
                            var data = JSON.parse(dataStr);
                            // 提取内容，可能在不同位置
                            if (data.choices && data.choices.length > 0) {
                                var choice = data.choices[0];
                                // 处理不同JSON结构
                                if (choice.delta && choice.delta.content) {
                                    fullContent += choice.delta.content;
                                }
                                else if (choice.message && choice.message.content) {
                                    fullContent += choice.message.content;
                                }
                                else if (choice.text) {
                                    fullContent += choice.text;
                                }
                                else if (typeof choice === 'string') {
                                    fullContent += choice;
                                }
                            }
                            else if (data.content) {
                                fullContent += data.content;
                            }
                            else if (data.message) {
                                fullContent += data.message;
                            }
                            else if (data.text) {
                                fullContent += data.text;
                            }
                            else if (typeof data === 'string') {
                                fullContent += data;
                            }
                        }
                        catch (e) {
                            // 如果不是JSON，可能是纯文本
                            fullContent += dataStr;
                        }
                    }
                    catch (e) {
                        console.warn('无法解析行:', line, e);
                        // 尝试直接使用行内容
                        var content = line.replace('data:', '').trim();
                        if (content && content !== '[DONE]') {
                            fullContent += content + ' ';
                        }
                    }
                }
            }
            // 如果没有提取到内容，可能是格式不符合预期
            if (!fullContent.trim()) {
                // 尝试其他格式或直接返回文本
                var cleanText = text.replace(/data:\s*\[DONE\]/g, '')
                    .replace(/data:/g, '')
                    .trim();
                return cleanText || "无法解析响应内容，请查看调试信息";
            }
            return fullContent;
        }
        catch (error) {
            console.error("解析流响应时出错:", error);
            // 最后尝试直接返回原始文本
            return text || "解析响应时出错";
        }
    };
    // 提交代码进行审查
    var submitCodeForReview = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, rawText, parsedContent, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!code.trim()) {
                        setError('请输入代码进行审查');
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    setLoading(true);
                    setError(null);
                    setDebugInfo(null);
                    return [4 /*yield*/, fetch(API_ENDPOINT, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'text/event-stream, application/json',
                            },
                            body: JSON.stringify({
                                messages: [
                                    {
                                        role: "user",
                                        content: "\u8BF7\u5BF9\u4EE5\u4E0B\u4EE3\u7801\u8FDB\u884C\u5BA1\u67E5\u5E76\u63D0\u4F9B\u6539\u8FDB\u5EFA\u8BAE\uFF1A\n\n```\n".concat(code, "\n```")
                                    }
                                ]
                            }),
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("API\u9519\u8BEF: ".concat(response.status));
                    }
                    return [4 /*yield*/, response.text()];
                case 3:
                    rawText = _a.sent();
                    setDebugInfo(rawText);
                    parsedContent = parseStreamResponse(rawText);
                    // 设置结果
                    setResult({ content: parsedContent });
                    return [3 /*break*/, 6];
                case 4:
                    err_1 = _a.sent();
                    console.error('请求错误:', err_1);
                    setError("\u8BF7\u6C42\u5931\u8D25: ".concat(err_1 instanceof Error ? err_1.message : String(err_1)));
                    setResult(null);
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // 自定义Markdown组件
    var MarkdownComponents = {
        code: function (_a) {
            var node = _a.node, inline = _a.inline, className = _a.className, children = _a.children, props = __rest(_a, ["node", "inline", "className", "children"]);
            var match = /language-(\w+)/.exec(className || '');
            if (!inline && match) {
                return (_jsx("div", { className: "code-block", children: _jsx("code", __assign({ className: className }, props, { children: children })) }));
            }
            return inline ? (_jsx("code", __assign({ className: "inline-code" }, props, { children: children }))) : (_jsx("div", { className: "code-block", children: _jsx("code", __assign({}, props, { children: children })) }));
        }
    };
    return (_jsx("div", { className: "min-h-screen bg-gray-900 text-gray-200 py-6 px-4", children: _jsxs("div", { className: "max-w-4xl mx-auto", children: [_jsx(AgentInfo, {}), !result && !loading && _jsx(WelcomeMessage, {}), _jsxs("div", { className: "chat-bubble mb-6", children: [_jsx("h2", { className: "text-lg font-medium mb-3", children: "\u8F93\u5165\u60A8\u8981\u5BA1\u67E5\u7684\u4EE3\u7801\uFF1A" }), _jsx("textarea", { className: "w-full h-64 bg-gray-950 text-gray-200 p-4 rounded-md font-mono text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4", value: code, onChange: function (e) { return setCode(e.target.value); }, placeholder: "// \u5728\u8FD9\u91CC\u7C98\u8D34\u60A8\u7684\u4EE3\u7801..." }), _jsx("div", { className: "flex justify-end", children: _jsx("button", { onClick: submitCodeForReview, disabled: loading, className: "bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-md flex items-center justify-center disabled:opacity-50 transition-colors", children: loading ? (_jsxs(_Fragment, { children: [_jsx(Loader2, { className: "w-5 h-5 mr-2 animate-spin" }), " \u6B63\u5728\u5206\u6790..."] })) : ('提交审查') }) }), error && (_jsx("div", { className: "mt-4 p-3 bg-red-900/50 border border-red-700 rounded-md text-red-300", children: error }))] }), result && (_jsxs("div", { className: "chat-bubble", children: [result.content && !result.content.includes('#') && !result.content.includes('*') && (_jsx("div", { className: "whitespace-pre-wrap", children: result.content })), result.content && (result.content.includes('#') || result.content.includes('*')) && (_jsx("div", { className: "markdown", children: _jsx(ReactMarkdown, { components: MarkdownComponents, remarkPlugins: [remarkGfm], children: result.content }) })), _jsx("div", { className: "mt-4 border-t border-gray-700 pt-4", children: _jsxs("details", { children: [_jsx("summary", { className: "cursor-pointer text-gray-400 text-sm", children: "\u8C03\u8BD5\u4FE1\u606F" }), _jsx("pre", { className: "mt-2 p-2 bg-gray-950 text-xs text-gray-400 overflow-auto rounded max-h-60", children: debugInfo })] }) })] }))] }) }));
};
export default CodeReviewUI;
